import template from './edit_document.html';
import tr from '../../lib/default-translator.js';

class DocumentEditViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.photofile = ko.observable();
		this.leave_type_id = ko.observable();
		this.allowed_values = ko.observableArray([ko.observable('')]);
		this.ll_cycle_date = ko.observable();
		this.available_leave_types = ko.observableArray();
		this.documents = ko.observableArray([]); 
		this.doc_types = ko.observableArray();

		this.new_name = ko.observable('');
		this.note = ko.observable('');
		this.selected_type_id = ko.observable();
		this.access_roles = ko.observableArray();
		this.selected_roles = ko.observableArray();
		this.is_expired = ko.observable(true);
		//this.valid_date = ko.observable('');
	}

	close()
	{
		this.dialog.close(false);
	}

	async load()
	{
		this.doc_types(await Grape.cache.get('GeneralDocumentTypes'));
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'access_role',
			schema: 'grape',
			sortfield: 'role_name',
			sortorder: 'asc',
			filter: [{
				value: ['guest', 'admin', 'manager', 'employee', 'accountant', 'general_manager', 'all', 'developer', 'director' ],
				operand: 'IN',
				field: 'role_name'
			}]
		});
		
		this.access_roles(res?.records || []);
	}
}

class DocumentEditPage
{
	constructor (bindings)
	{
		this.viewModel = new DocumentEditViewModel(this);
		this.bindings = bindings;

		if (bindings.document_data.valid_date == null)
			this.viewModel.is_expired(false);
	}

	async init()
	{	
		this.viewModel.access_roles(await Grape.cache.get('AccessRoleLookup') || []);
		this.viewModel.doc_types(await Grape.cache.get('EmployeeDocumentTypeLookup') || []);
		this.viewModel.documents.push(this.bindings.document_data);
	}

	async approve_document()
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Confirm'), message: tr('Are you sure you want to approve this document?')});
		if (response)
		{
			let data = this.viewModel.documents()[0];
			data.edit_mode = true;

			if (data.valid_date == "" || this.viewModel.is_expired() == false)
				data.valid_date = null;

			try {
				let res = await Grape.fetches.postJSON('/admin/approve_document', data);
				if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', title: tr('Success', 'Success'), message: tr('Successfully approved document.')});
					this.close(true)
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', title: tr('Error', 'Error'), message: tr('An error occurred while approving the document..') });
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({ type: 'error', title: tr('Error', 'Error'), message: tr('An error occurred while approving the document..') });
			}
		}
		else
			return;
	}
};

export default {
	name: 'EditDocument',
	dialog_class: DocumentEditPage,
	template: template,
	template_filename: 'translation/dialogs/upload_general_document',
	provider: 'ps'
};
